<template>
    <div class="settlement-detail" v-loading="loading">
        <div class="content-box first">
            <div class="sr-descriptions" v-if="detail.status">
                <div class="item">
                    <label>结算状态</label>
                    <div class="text">

                        <template v-if="detail.status != 3 && detail.status != 5">
                            <span class="color-warning bold">待结算</span>
                            <span>
                                ，你还有 {{ detail.partnersShouldSettlementAmount }} {{ detail.currency }} 未提现{{
                                    isAlipay ? '，完善账号才能提现' : ''
                                }}
                            </span>
                        </template>
                        <template v-else>
                            <span v-if="detail.status == 5" class="color-theme bold">待结清</span>
                            <span v-else class="color-success bold">提现完成</span>
                        </template>
                    </div>
                </div>
                <div class="item" v-if="detail.status == 3 || detail.status == 5">
                    <label>已提现收益</label>
                    <div class="text">
                        <Amount
                            style="line-height: 21px"
                            size="samll"
                            :value="
                                ((detail.status == 5 ? detail.withdrawnAmount : detail.partnersShouldSettlementAmount) || 0).toLocaleString('zh', {
                                    minimumFractionDigits: 2,
                                })
                            "
                        ></Amount>
                    </div>
                </div>
                <div class="item" v-if="detail.status == 3 || detail.status == 5">
                    <label>打款账号</label>
                    <div class="text">
                        <p v-for="(item, index) in detail.cpWithdrawSheet" :key="index" style="margin-bottom: 10px">
                            {{ $utils.formatDate(item.withdrawnTime, 'yyyy-MM-dd HH:mm') }}
                            汇款
                            <span class="bold">{{ item.withdrawAmount }}{{ item.currency }}</span>
                            至{{ item.payType == 3 ? '银行卡号' : '支付宝账号' }}({{ item.payeeAccount || '' }})
                        </p>
                    </div>
                </div>
                <div class="item">
                    <label>授权方</label>
                    <div class="text">{{ detail.cpName }}</div>
                </div>
                <div class="item">
                    <label>结算协议</label>
                    <div class="text">{{ detail.contractCode }}</div>
                </div>
                <div class="item">
                    <label>结算周期</label>
                    <div class="text">
                        {{ $utils.formatDate(detail.beginTime, 'yyyy-MM') }}
                        - {{ $utils.formatDate(detail.endTime, 'yyyy-MM') }}</div>
                </div>
                <div class="item">
                    <label>结算货币</label>
                    <div class="text">
                        {{ detail.currency }}
                    </div>
                </div>
                <!-- <div class="item">
                    <label>分成比例</label>
                    <div class="text">{{ detail.dividedProportion * 100 }}%</div>
                </div> -->
            </div>
        </div>
        <div class="content-box">
            <div class="title">
                结算金额
                <el-button @click="visible = true" type="text" class="underline">
                    <span class="down-icon"></span>
                    下载结算单
                </el-button>
            </div>
            <div class="sr-descriptions">
                <el-table :data="detail.bizAccountings" style="width: 100%; margin: 30px 0">
                    <el-table-column prop="spName" label="参与分配金额">
                        <template slot-scope="scope">
                            {{ scope.row.totalAmount ? (parseInt(scope.row.totalAmount * 100) / 100).toFixed(2) : '0.00' }}
                            {{ detail.currency }}
                        </template>
                    </el-table-column>
                    <el-table-column label="分成比例">
                        <template slot-scope="scope">{{ scope.row.split ? (scope.row.split * 100).toFixed(0) : '0' }}%</template>
                    </el-table-column>
                    <el-table-column label="抵扣">
                        <template slot-scope="scope">
                            {{ scope.row.deductibleMoney ? (parseInt(scope.row.deductibleMoney * 100) / 100).toFixed(2) : '0.00' }}
                            {{ detail.currency }}
                        </template>
                    </el-table-column>
                    <el-table-column label="授权方应结算金额">
                        <template slot-scope="scope">
                            {{ scope.row.shouldSettlementAmount ? (parseInt(scope.row.shouldSettlementAmount * 100) / 100).toFixed(2) : '0.00' }}
                            {{ detail.currency }}
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <div class="item" v-if="detail.allDeductibleMoney">
                    <label>本次抵扣金额</label>
                    <div class="text">{{ detail.allDeductibleMoney }} {{ detail.currency }}</div>
                </div>
                <div class="item" v-if="detail.cumulativeSurplusDeductibleMoney">
                    <label>累计未抵扣金额</label>
                    <div class="text">{{ detail.cumulativeSurplusDeductibleMoney }} {{ detail.currency }}</div>
                </div> -->
                <div class="item" v-if="detail.adjustmentAccountAmount">
                    <label>本次调账金额</label>
                    <div class="text">
                        {{ detail.adjustmentAccountAmountOperator }} {{ detail.adjustmentAccountAmount }} {{ detail.currency }}
                        <p>备注：{{ detail.adjustmentAccountNote || '无' }}</p>
                    </div>
                </div>
                <div class="item" v-if="detail.ownToAmount">
                    <label>分账通（我方）分出</label>
                    <div class="text">-{{ detail.ownToAmount }} {{ detail.currency }}</div>
                    <el-button type="text" @click="downloadSellSplitDetail(1)" class="underline">下载详情表</el-button>
                </div>
                <div class="item" v-if="detail.otherToOwnAmount">
                    <label>分账通（他人）分入</label>
                    <div class="text">{{ detail.otherToOwnAmount || 0 }} {{ detail.currency }}</div>
                    <el-button type="text" @click="downloadSellSplitDetail(2)" class="underline">下载详情表</el-button>
                </div>
                <div class="item">
                    <label>代缴税费</label>
                    <div class="text">{{ detail.taxAmount ? `-${detail.taxAmount}` : '0' }} {{ detail.currency }}</div>
                </div>
                <div class="item" v-if="detail.partnersShouldSettlementAmount">
                    <label>总金额</label>
                    <div class="text">{{ detail.partnersShouldSettlementAmount }} {{ detail.currency }}</div>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="title">
                专辑销售明细
                <el-button class="underline" v-if="detail && detail.spDetails &&detail.spDetails.length > 0" @click="downloadSellReport" type="text">
                    <span class="down-icon"></span>
                    下载销售报告
                </el-button>
            </div>
            <div class="page-list-box">
                <el-table v-loading="loading" :data="detail.spDetails" style="width: 100%">
                    <el-table-column prop="spName" label="渠道"></el-table-column>
                    <el-table-column label="使用时间">
                        <template slot-scope="scope">
                            {{ $utils.formatDate(scope.row.beginStatisticsTime, 'yyyy-MM') }}
                        - {{ $utils.formatDate(scope.row.endStatisticsTime, 'yyyy-MM') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="净收入">
                        <template slot-scope="scope">
                            {{ scope.row.cpCanSettleAmount ? (parseInt(scope.row.cpCanSettleAmount * 100) / 100).toFixed(2) : '0.00' }}
                            {{ detail.currency }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <dhmPayment :visible.sync="visible" :detail="detail"></dhmPayment>
    </div>
</template>

<script>
import dhmPayment from '../components/dmhPayment';
import {downLoadByUri, downLoadByBlob} from '@/api/file';
const defaultQuery = {
    cpSettlementSheetId: ''
};
export default {
    components: {
        dhmPayment
    },
    data() {
        return {
            filterData: {...defaultQuery},
            tabsName: '1',
            loading: false,
            detail: {
                status: 0,
            },
            visible: false,
        };
    },
    computed: {
        shouldSettlementAmount() {
            const {shouldSettlementAmount, adjustmentAccountAmount, adjustmentAccountAmountOperator} = this.detail || {};
            if (!shouldSettlementAmount) return 0;
            return adjustmentAccountAmountOperator == '+'
                ? shouldSettlementAmount + adjustmentAccountAmount
                : shouldSettlementAmount - adjustmentAccountAmount;
        },
        isAlipay() {
            const {alipayStatus} = this.$store.state.userInfo;
            return alipayStatus && alipayStatus == 1 ? true : false;
        },
    },
    created() {
        this.filterData.cpSettlementSheetId = this.$route.params.id;
        this.fetchDetail();
    },
    methods: {
        async fetchDetail() {
            this.loading = true;
            const response = await this.$request({
                url: '/cp-income/view/dmh-settlement-detail',
                method: 'POST',
                data: {cpSettlementSheetId: this.$route.params.id},
            });
            const {msg, state, result} = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '');
            this.detail = result;
        },
        downloadSellReport() {
            if (!this.detail.salesDataSummaryFileUrl) return this.$message.error('暂无销售数据下载');
            downLoadByUri(this.detail.salesDataSummaryFileUrl, '销售单数据.zip');
        },
        async downloadSellSplitDetail(type) {
            const response = await this.$request({
                url: '/cpBoss/download/settlement/splitDetail',
                method: 'GET',
                responseType: 'blob',
                params: {cpSettlementId: this.$route.params.id, type},
            });
            downLoadByBlob(new Blob([response.data]), decodeURIComponent(`${type == 1 ? '分出' : '分入'}详情表.xlsx`));
        },
    },
};
</script>
<style lang="scss"></style>
